<template>
    <div class="container-fluid">
        <div class="forget-password">
            <div class="card p-sm-5 p-3" style="width: 25rem;">
                <h5 class="card-title text-center text-white"><img src="/assets/logo/logo_white.svg" alt=""></h5>
                <div class="card-body pt-0" v-if="verified">
                    <form @submit.prevent="submit()">
                        <div class="form-group mt-3">
                            <p class="text-white text-uppercase">WACHTWOORD RESETTEN</p>
                            <small class="text-white"> Het wachtwoord moet minimaal 1 hoofdletter, 1 kleine letter en 1 speciaal teken bevatten. De lengte is minimaal 6 tekens.</small>
                        </div> 
                        <div class="form-group mt-4 p-1">
                            <input :class="{'error':password_validation.status == -1}" type="password" class="form-control" placeholder="Nieuw wachtwoord" v-model="password" name="">
                            <small v-if="password_validation.status == -1">{{password_validation.text}}</small>
                        </div>
                        <div class="form-group mt-4 p-1">
                            <input :class="{'error':password_confirmation_validation.status == -1}" type="password" class="form-control" placeholder="Bevestig nieuw wachtwoord" v-model="password_confirmation" name="">
                            <small class="text-danger" v-if="password_confirmation_validation.status == -1">{{password_confirmation_validation.text}}</small>
                        </div>
                        <div class="form-group text-center">
                            <button type="submit" class="btn btn-dark mt-4">
                                <span v-if="resetting">Aan het opslaan...</span>
                                <span v-else>Opslaan</span>
                            </button>
                        </div>
                    </form>
                </div>
                <div class="card-body pt-0" v-if="!verified && loading">
                    <p>Wachtwoord reset token aan het valideren</p>
                </div>
                <div class="card-body pt-0" v-if="!verified && !loading" style="background: white;text-align: center;border-radius: 5px;padding: 15px 0px;">
                    <p class="p-0 m-0 text-danger">De wachtwoord reset link is ongeldig</p>
                    <a class="p-0 mt-3 d-block" href="/forgot-password">Klik hier om het wachtwoord te resetten</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
    export default {
        name: "forgetPassword",
        data(){
            return {
                email:'',
                verified:false,
                loading:false,
                resetting:false,
                password:'',
                password_confirmation:'',
                id:0,
                token:'',
                password_validation:{
                    status:0,
                    text:''
                },
                password_confirmation_validation:{
                    status:0,
                    text:''
                },
            }
        },
        watch:{
            password(value){
                this.validatePassword(value);
            },
            password_confirmation(value){
                if(this.password != value){
                    this.password_confirmation_validation.status = -1;
                    this.password_confirmation_validation.text = "Wachtwoorden zijn niet gelijk.";
                    return false;
                }
                this.password_confirmation_validation.status = 1;
            }
        },
        methods:{
            ...mapActions({
                displayNotification: 'auth/displayNotification',
            }),
            validatePassword(password){
                this.password_validation.status = 0;
                this.password_validation.text = '';

                if(!password.match(/[a-z]/)){
                    this.password_validation.status = -1;
                    this.password_validation.text = 'Wachtwoord moet minimaal 1 kleine letter bevatten';
                    return false;
                }
                if(!password.match(/[A-Z]/)){
                    this.password_validation.status = -1;
                    this.password_validation.text = 'Wachtwoord moet minimaal 1 hoofdletter bevatten';
                    return false;
                }
                if(!password.match(/[$@#&!./%^*({}~`)\\]/)){
                    this.password_validation.status = -1;
                    this.password_validation.text = 'Wachtwoord moet minimaal 1 speciaal karakter bevatten';
                    return false;
                }
                if(password.length < 6){
                    this.password_validation.status = -1;
                    this.password_validation.text = 'Wachtwoord moet minimaal 6 karakters bevatten';
                    return false;
                } 
                this.password_validation.status = 1;
            },
            
            submit(){     
                if(this.password_validation.status != 1 || this.password_confirmation_validation.status != 1){
                    return false;
                }            
                
                if(this.password != this.password_confirmation){
                    this.displayNotification({type:'danger',title:'Validation Error','message':"wachtwoord voldoet niet aan bovenstaande eisen, probeer opnieuw.",id:Math.round(Math.random() * 999),autoDismiss:true,interval:2000})
                    return false;
                }

                this.resetting=true;
                var payload = {
                    password : this.password,
                    password_confirmation : this.password_confirmation,
                    id:this.id,
                    token:this.token
                };
                this.$store.dispatch('post',{
                    endpoint:'api/v1/reset-password',
                    details:payload
                })
                .then((data)=>{
                    this.resetting=false;
                    console.log(data); 
                    this.displayNotification({type:'success',title:'Success','message':"Wachtwoord gewijzigd",id:Math.round(Math.random() * 999),autoDismiss:true,interval:2000})
                    this.$router.push({path:'/login'});
                })
                .catch((error)=>{
                    console.log(error.request);
                   this.resetting=false;
                });
            }
        },
        created(){
            this.loading = true
            this.$store.dispatch('post',{
                endpoint:'api/v1/verify-password',
                details:{token:this.$route.params.token}
            })
            .then((data)=>{
                this.verified=true;
                this.loading = false;
                this.id = data.data;
                this.token = this.$route.params.token;
            })
            .catch((error)=>{
                console.log(error.request);
                this.loading=false;
            });
        }
    }
</script>

<style scoped>
    .error{
        border: 1px solid red !important;
    }
    .container-fluid {
        height: 100vh;
        background: transparent linear-gradient(270deg, #73AFE3 0%, #CFE4F6 100%) 0% 0% no-repeat padding-box;
        opacity: 1;
    }

    .forget-password {
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
    }

    .card {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 20px;
        opacity: 1;
    }

    .form-control {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        height: calc(1.5em + .75rem + 8px) !important;
        font-size: 15px !important;
    }

    .btn {
        background: #292929 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        padding-left: 15%;
        padding-right: 15%;
        font-size: 18px !important;
    }

</style>
